"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageList = exports.LanguageContext = exports.LangCasing = void 0;
exports.LanguageProvider = LanguageProvider;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _Contents = require("./Contents");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @callback TranslateFormatter
 * @param {string[]} translatedList
 */
var defaultLocale = 'en-US';
/**
 * Language-cultureCode mapping
 */

var LanguagesMapping = {
  'en-CA': 'enCA',
  'en-US': 'enUS',
  'fr-CA': 'frCA'
};
var LanguagesToLocales = new Map(Object.keys(LanguagesMapping).map(function (k) {
  return [LanguagesMapping[k], k];
}));
var LangCasing = {
  upper: 'upper',
  lower: 'lower',
  cap: 'cap'
};
exports.LangCasing = LangCasing;
var LanguageList = Object.keys(LanguagesMapping).sort(function (a, b) {
  var aValue = '';
  var bValue = '';

  if (a !== defaultLocale) {
    aValue = a;
  }

  if (b !== defaultLocale) {
    bValue = b;
  }

  if (aValue > bValue) {
    return 1;
  }

  if (aValue < bValue) {
    return -1;
  }

  return 0;
});
exports.LanguageList = LanguageList;

var getLocaleFromLanguage = function getLocaleFromLanguage(locale) {
  return LanguagesToLocales.get(locale);
};

var LanguageContext = /*#__PURE__*/(0, _react.createContext)({
  language: getLocaleFromLanguage(defaultLocale),
  languageResource: _Contents.languageResourceList.enUS
});
/**
 * @function changeCasing
 * @param {string} text The text to format.
 * @param {LangCasing} casing - The casing of the text. Lowercase keys should be used for proper casing
 * @param {string} locale - culture code
 * @returns {string} The formatted text.
 * */

exports.LanguageContext = LanguageContext;

function changeCasing(text, casing, locale) {
  var result = text;

  switch (casing) {
    case LangCasing.cap:
      result = result[0].toUpperCase() + result.substring(1);
      break;

    case LangCasing.upper:
      result = result.toLocaleUpperCase(locale);
      break;

    default:
      result = result.toLocaleLowerCase(locale);
  }

  return result;
}

var currencyFormatters = new Map();

function getUSDFormatters(locale) {
  if (!currencyFormatters.has(locale)) {
    currencyFormatters.set(locale, new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'narrowSymbol'
    }));
  }

  return currencyFormatters.get(locale);
}

function LanguageProvider(_ref) {
  var children = _ref.children,
      selectedLanguage = _ref.selectedLanguage;

  var _useState = (0, _react.useState)(LanguagesMapping[selectedLanguage]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      language = _useState2[0],
      setLanguage = _useState2[1];

  var provider = {
    language: language,
    languageResource: _Contents.languageResourceList[language],
    languageHandler: function languageHandler(selected) {
      setLanguage(_Contents.languageOptions[LanguagesMapping[selected]] ? LanguagesMapping[selected] : LanguagesMapping[selectedLanguage]);
    },

    /* NOTE: Separate translate functions to handle edge cases.
     * We are also under the assumption that translators like Google Translate
     * are not accurate enough.
     */

    /**
     * @function translate
     * @param {string} text English text to be translated. Usually useful for one word translations.
     * @param {LangCasing} casing - The casing of the translation. Lowercase keys should be used for proper casing
     *  @returns {string} The translated text.
     * @inner
     */
    translate: function translate(text, casing) {
      var result = '';
      var key = text;

      if (casing) {
        var locale = provider.getCurrentLocale();
        key = key.toLowerCase();
        result = _Contents.languageResourceList[language].translations[key] || text;
        result = changeCasing(result, casing, locale);
      } else {
        result = _Contents.languageResourceList[language].translations[key] || text;
      }

      return result;
    },

    /**
     * @function translateAll
     * @param {string[]} textList A list of English text to be translated. Usually useful for one word translations.
     * @param {TranslateFormatter?=} formatter
     * @returns The translated list of text or any return based on the optional formatter callback.
     * @inner
     */
    translateAll: function translateAll(textList, formatter) {
      var translatedList = textList.map(function (txt) {
        return provider.translate(txt);
      });

      if (!formatter) {
        return translatedList;
      }

      return formatter(translatedList);
    },

    /**
     * @function translateKey
     * @description Takes a description key (path) to get the proper translation. Useful for large blocks of text.
     * This is a descriptive key. The followed pattern should be parentComponent.componentToTranslate.
     * @param {string} key The path to the translation. The depth is denoted by '.'. For example root.nest1.nest2.
     * @param {any} options asVariables - Determines if the text contains keys as variables, root - The new parent root
     * @returns The translated list of text or any return based on the optional formatter callback.
     * @inner
     */
    translateKey: function translateKey(key, options) {
      var result = '';

      var _ref2 = options || {},
          asVariables = _ref2.asVariables,
          root = _ref2.root;

      var getKey = function getKey(k) {
        return root ? "".concat(root, ".").concat(k) : k;
      };

      if (asVariables) {
        result = key;
        var matches = (0, _toConsumableArray2["default"])(key.matchAll('{[^}]*}')).map(function (m) {
          return m[0];
        });
        var allKeys = matches.map(function (k) {
          return k.replace('{', '').replace('}', '');
        });
        allKeys.forEach(function (k, i) {
          result = result.replace(matches[i], provider.translateKey(k, {
            asVariables: false,
            root: root
          }));
        });
      } else {
        var realKey = getKey(key);
        var tokens = (realKey || '').split('.'); // Check for direct translation first

        result = _Contents.languageResourceList[language].translations[realKey];

        if (result) {
          return result;
        }

        result = _Contents.languageResourceList[language].translationsByKey;

        for (var i = 0; i < tokens.length && result; i += 1) {
          var curToken = tokens[i];

          if (!curToken) {
            return realKey;
          }

          result = result[curToken];
        }
      } // Reference the direct translation


      if ((0, _typeof2["default"])(result) === 'object') {
        result = provider.translate(result.ref, result.casing);
      }

      return result || key;
    },

    /**
     * @function createTranslateKey
     * @description Same functionality as translateKey, but this function creates a translateKey that uses a specified root.
     * @param {string} newRoot
     * @param {any} options
     * @returns New translateKey function.
     * @inner
     */
    createTranslateKey: function createTranslateKey(newRoot) {
      return function (key, options) {
        return provider.translateKey(key, _objectSpread({
          root: newRoot
        }, options || {}));
      };
    },

    /**
     * @function getCurrentLocale
     * @returns the selected locale
     */
    getCurrentLocale: function getCurrentLocale() {
      return getLocaleFromLanguage(language);
    },

    /**
     * @function translateCurrency
     * @description translates a number or number string into the proper currency for the selected locale
     * @param {string | number} number
     * @returns number formatted as a currency string
     * @inner
     */
    translateCurrency: function translateCurrency(number) {
      var formatter = getUSDFormatters(provider.getCurrentLocale());
      return formatter.format(number || 0);
    },

    /**
     * @function translateCurrencyToParts
     * @description translates a number or number string into the proper currency for the selected locale
     * @param {string | number} number
     * @returns number formatted as parts - integer, decimal, group, literal, fraction, currency
     * @inner
     */
    translateCurrencyToParts: function translateCurrencyToParts(number) {
      var formatter = getUSDFormatters(provider.getCurrentLocale());
      return formatter.formatToParts(number || 0);
    },

    /**
     * @function translateCurrencyToParts
     * @description translates a number or number string into the proper currency for the selected locale
     * @param {string | number} number
     * @returns number formatted as simple parts - whole, decimal, literal, fraction, currency
     * @inner
     */
    translateCurrencyToSimpleParts: function translateCurrencyToSimpleParts(number) {
      var result = [];
      var prevType = '';
      var whole = [];

      function getType(type) {
        return type === 'integer' || type === 'group' ? 'whole' : type;
      }

      function addWholeToResults() {
        result.push({
          type: 'whole',
          value: whole.join('')
        });
      }

      function updateResults(type, value) {
        if (prevType === 'whole' && type !== 'whole') {
          addWholeToResults();
        }

        if (type !== 'whole') {
          result.push({
            type: type,
            value: value
          });
        }
      }

      provider.translateCurrencyToParts(number).forEach(function (part) {
        var type = getType(part.type);

        if (type === 'whole') {
          whole.push(part.value);
        }

        updateResults(type, part.value);
        prevType = type;
      }); // If there is no currency or fraction

      if (prevType === 'whole') {
        addWholeToResults();
      }

      return result;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(LanguageContext.Provider, {
    value: provider
  }, children);
}

LanguageProvider.propTypes = {
  children: _propTypes.node.isRequired,
  selectedLanguage: _propTypes.string
};
LanguageProvider.defaultProps = {
  selectedLanguage: 'en-US'
};
LanguageProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LanguageProvider",
  "props": {
    "selectedLanguage": {
      "defaultValue": {
        "value": "'en-US'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    }
  }
};